import { forwardRef } from 'react';
import styles from './StyleConstants.module.css';

export const BentoHeading = forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, children, ...props }, ref) => (
  <h4
    ref={ref}
    className={className ? `${styles.BentoHeading} ${className}` : styles.BentoHeading}
    {...props}
  >
    {children}
  </h4>
));
BentoHeading.displayName = 'BentoHeading';

export const BentoPara = forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, children, ...props }, ref) => (
  <p
    ref={ref}
    className={className ? `${styles.BentoPara} ${className}` : styles.BentoPara}
    {...props}
  >
    {children}
  </p>
));
BentoPara.displayName = 'BentoPara';
